
import { Component, Mixins, Prop } from 'vue-property-decorator'
import Testable from '@/mixins/Testable'

@Component
export default class ConfirmationDialog extends Mixins(Testable) {
	@Prop({
		type: Boolean,
		required: true,
		default: false
	})
	opened!: boolean

	@Prop({ required: false, default: 650 })
	maxWidth!: number

	@Prop({ required: true })
	actionType!: string

	@Prop({ required: true })
	actionSubject!: string

	@Prop({ required: false, default: false })
	loading!: boolean
}
